import type { LatitudeLongitude } from '@nora-monorepo/shared';

export interface MapConfigBaseMap {
  id: string;
  visible: boolean;
  name: string;
}

export interface MapConfigOverlayMap extends MapConfigBaseMap {}

export interface MapConfigOfflineMap extends MapConfigBaseMap {}

/**
 * A single operation shown on a map, together with its eye-toggle visibility.
 * A map can show any number of operations simultaneously.
 */
export interface MapConfigOperation {
  id: string;
  visible: boolean;
}

export enum MapMode {
  Normal = 'normal',
  Draw = 'draw',
}

/**
 * Map configuration interface
 * This interface defines the configuration options necessary to initialize a map instance.
 */
export interface MapConfig {
  id: string;
  operations: MapConfigOperation[];
  activeOperationId?: string;
  zoom: number;
  rotation: number;
  center: LatitudeLongitude;
  projection: string;
  baseMap?: string;
  overlayMaps: MapConfigOverlayMap[];
  offlineMaps: MapConfigOfflineMap[];
  mode: MapMode;
  followedProducerId?: string;
  activeDrawLayerId?: string;
  headingUpMode?: boolean;
}
export enum CompositeLayerId {
  BaseMaps = 'baseMaps',
  OverlayMaps = 'overlayMaps',
  UtilOverlays = 'utilOverlays',
  NoraOverlays = 'noraOverlays',
}

export enum LocationButtonState {
  Idle = 0,
  CenteredOnUser = 1,
  ZoomedToLevel1 = 2,
  ZoomedToLevel2 = 3,
}

export interface UpdateMapLocationParameters {
  latitude: number;
  longitude: number;
  zoom?: number;
}
